<template>
  <modal
    name="private-relay-warning-dialog"
    :adaptive="true"
    :scrollable="true"
    height="auto"
    :clickToClose="false"
    class="private-relay-modal-overlay"
    @before-close="onBeforeClose"
  >
    <div class="v--modal-close-top">
      <el-button
        @click="close"
        icon="el-icon-circle-close"
        type="text"
      ></el-button>
    </div>
    <div class="private-relay-warning">
      <p class="private-relay-warning__icon">⚠️</p>
      <h3 class="private-relay-warning__title">メールアドレスのご確認</h3>
      <p class="private-relay-warning__txt">
        現在、Appleの「メールを非公開」機能をご利用中のため、各種お知らせメールが届かない場合があります。
      </p>
      <ul class="private-relay-warning__list">
        <li>お支払いの確認・更新のお知らせ</li>
        <li>メール便の送信通知・企業からの返信</li>
      </ul>
      <p class="private-relay-warning__txt">
        正常にサービスをご利用いただくために、受信可能なメールアドレスへの変更をおすすめします。
      </p>
      <div class="private-relay-warning__actions">
        <a href="/mypage/basicinfo" class="private-relay-warning__btn-primary"
          >メールアドレスを変更する</a
        >
        <button @click="proceed" class="private-relay-warning__btn-secondary">
          このまま購入する
        </button>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  name: 'PrivateRelayWarningDialog',
  data() {
    return {
      onProceed: null
    }
  },
  methods: {
    show(callback) {
      this.onProceed = callback || null
      this.$modal.show('private-relay-warning-dialog')
    },
    close() {
      this.onProceed = null
      this.$modal.hide('private-relay-warning-dialog')
      this.$eventHub.$emit('loading_off')
    },
    onBeforeClose() {
      this.onProceed = null
      this.$eventHub.$emit('loading_off')
    },
    proceed() {
      const callback = this.onProceed
      this.onProceed = null
      this.$modal.hide('private-relay-warning-dialog')
      if (callback) {
        callback()
      }
    }
  },
  created() {
    this.$eventHub.$on('show-private-relay-warning', this.show)
  },
  beforeDestroy() {
    this.$eventHub.$off('show-private-relay-warning', this.show)
  }
}
</script>

<style scoped>
.private-relay-warning {
  padding: 30px 20px;
  text-align: center;
}

.private-relay-warning__icon {
  font-size: 40px;
  margin-bottom: 10px;
}

.private-relay-warning__title {
  font-size: 18px;
  font-weight: bold;
  color: #e3165c;
  margin-bottom: 15px;
}

.private-relay-warning__txt {
  font-size: 14px;
  color: #333;
  margin-bottom: 10px;
  line-height: 1.6;
}

.private-relay-warning__list {
  text-align: left;
  display: inline-block;
  margin: 10px 0 15px;
  padding-left: 20px;
  font-size: 14px;
  color: #333;
  line-height: 1.8;
}

.private-relay-warning__actions {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.private-relay-warning__btn-primary {
  display: inline-block;
  background: #e3165c;
  color: #fff;
  padding: 10px 30px;
  border-radius: 25px;
  font-size: 14px;
  font-weight: bold;
  text-decoration: none;
  border: none;
  cursor: pointer;
}

.private-relay-warning__btn-primary:hover {
  opacity: 0.85;
  text-decoration: none;
  color: #fff;
}

.private-relay-warning__btn-secondary {
  background: none;
  border: none;
  color: #999;
  font-size: 13px;
  cursor: pointer;
  padding: 5px 15px;
}

.private-relay-warning__btn-secondary:hover {
  color: #666;
}
</style>

<style>
.private-relay-modal-overlay.v--modal-overlay {
  z-index: 10000 !important;
}
</style>
